let roomsRendered = [];
export function setRoomsRendered(newRooms) {
    roomsRendered = newRooms
        .filter((d) => d.dataset.id) // skip over any without a valid id
        .sort((a, b) => Number(a.dataset.order) - Number(b.dataset.order)); // order based on configuration;
    return roomsRendered;
}
export function getRoomByIndex(index) {
    return roomsRendered[index];
}
export function getRoomsRendered() {
    return roomsRendered;
}
